import React from 'react'

export default function TreeInfoPane({ info }) {
  if (!info || !info.info || info.info.length === 0) {
    return (
      <div className="glass-panel border-t p-4 text-sm text-gray-500 italic dark:text-gray-400 shadow-md">
        Hover over a person for their information.
      </div>
    )
  }

  return (
    <div className="glass-panel border-t p-4 text-sm dark:text-gray-200 shadow-md">
      <span className="text-gray-800 dark:text-gray-100">
        About <i className="text-blue-600 dark:text-blue-400 font-semibold">{info.name}</i>:
      </span>
      <ul className="list-disc ml-5 mt-2 space-y-1">
        {info.info.map((item, i) => (
          <li key={i} className="text-gray-700 dark:text-gray-300">{item}</li>
        ))}
      </ul>
    </div>
  )
}
